import React from 'react';
import { connect } from 'react-redux';
import debounce from 'debounce';

import {
  Col,
  Row,
  List,
  Avatar,
  Checkbox,
  Collapse,
  message,
  Button,
  Popconfirm,
  InputNumber,
  Icon,
  Tag,
  Tooltip
} from 'antd';


import {
  _deleteHoldingList,
  _deleteHoldingListProduct,
  _postSetCustomBulkDiscount,
  _postUpdateHoldingListQuantity,
  _postUpdateHoldingListSerialNumber
} from '../../../services';

import './modal.css'

const Panel = Collapse.Panel;

class HoldingList extends React.Component {

  render() {

    return (
      <div key="holding-list-selector" className="holding-list-body">
        <div id="style-3">

          <Row gutter={8}>
            <h3
              style={{marginLeft:10}}
            >Holding Lists:</h3>
          </Row>

          {this.props.holdingList.map((hl, index) => (
            <Row key={index} style={{ marginBottom: 16 }}>
              <Col span={22}>
                <Collapse 
                  activeKey={[
                    this.props.selectedListId, 
                    ...this.state.activeKeys
                  ]} 
                  onChange={this.handleOnToggleCollapse}>

                  <Panel  
                    header={(
                      <Tooltip
                        placement="right"
                        title={hl.notes}>
                        {hl.name}: {hl.products.length} products
                      </Tooltip>
                    )}
                    key={hl._id} >

                    <Row>
                      <List
                        itemLayout="horizontal"
                        dataSource={hl.products}
                        renderItem={(_item, productIndex) => (
                        
                          <List.Item 
                            actions={[
                              <a 
                                onClick={() => this.handleDeleteProduct(hl._id, productIndex)}>
                                  <Icon type="close" />
                              </a>
                            ]}>

                            <Row type="flex" align="middle" justify="center" style={{width: '100%'}}>

                              <Col span={4}>

                                <InputNumber
                                  style={{ width: '60px' }}
                                  onChange={ newSerialNumber => this.handleChangeSerialNumber(hl._id, newSerialNumber, productIndex)}
                                  value={_item.serialNumber}
                                />
                              
                              </Col>

                              <Col span={18}>

                                <List.Item.Meta
                                  avatar={<Avatar src={_item.product.images[0].url} shape="square" size="large" />}
                                  title={ this.renderItemName( _item ) }
                                  description={(
                                  <Row>
                                    {this.renderVariantName(_item.variants)}
                                    {this.renderPrice(_item, productIndex, hl._id)}

                                  </Row>
                                  )}
                                />

                              </Col>
          
                              <Col span={2}>

                                <InputNumber
                                  style={{ width: '60px' }}
                                  onChange={ quantity => this.onQuantityChange({
                                    holdingListId: hl._id,
                                    productIndex,
                                    quantity
                                  })}
                                  value={_item.quantity}
                                  min={1}
                                />

                              </Col>

                            </Row>

                          </List.Item>
                        )}
                      />

                    </Row>

                    <Row type="flex" justify="center">
                      <Col span={12} align="middle">
                      <Popconfirm 
                          title="Are you sure?" 
                          onConfirm={() => this.handleReorderHoldingList(hl._id)} 
                          okText="Yes" 
                          cancelText="No">
                          
                          <Button>Reorder</Button>
                        
                        </Popconfirm>
                      </Col>
                      <Col span={12} align="middle">
                        <Popconfirm 
                          title="Are you sure?" 
                          onConfirm={() => this.handleDeleteHoldingList(hl._id)} 
                          okText="Yes" 
                          cancelText="No">
                          
                          <Button type="danger">Delete</Button>

                        </Popconfirm>
                      </Col>
                    </Row>
                  </Panel>

                </Collapse>
              </Col>

              <Col span={2} align="middle">
                <Checkbox
                  onChange={ () => this.props.setSelectedHoldingListid( hl._id ) }
                  checked={ hl._id === this.props.selectedListId }
                  key={ hl._id }
                />
              </Col>

            </Row>
          ))}

        </div>
      </div>
    )

  }

  renderFreeDeliveryTag = ( productOrder ) => {

    if( productOrder.product.movFreeDelivery ){
      
      let totalPrice = this.getTotalPrice(productOrder);

      if( (totalPrice * productOrder.quantity) > productOrder.product.movFreeDelivery ){
        return (
          <Tag 
            style={{ marginLeft: 8 }} 
            color="green">Free Delivery</Tag>
        );
      } else {
        return (
          <Tag 
            style={{ marginLeft: 8 }}
            color="orange">Free Delivery > {productOrder.product.movFreeDelivery}
          </Tag>
        )
      }

    }

    return null;
    // return (
    //     {
    //       product.product.movFreeDelivery? 
    //       (
    //         <Tag style={{ marginLeft: 8 }} colour="green">Free Delivery > {product.product.movFreeDelivery}</Tag>
    //       ): 
    //       ""
    //     }
    // )
  }

  renderItemName = ( product ) => {

    return (
      <div>
        {product.product.title}
        {this.renderFreeDeliveryTag(product)}
        {/* {
          product.product.movFreeDelivery? 
          (
            <Tag style={{ marginLeft: 8 }} colour="green">Free Delivery > {product.product.movFreeDelivery}</Tag>
          ): 
          ""
        } */}
      </div>
    )
    
  }

  renderVariantName = ( variants ) => {

    if( !variants ){
      return null;
    }

    const variantKeys = Object.keys(variants);

    return (
      <Row style={{ fontSize: 12, color: "#595959"}}>
        {variantKeys.map(
          key => (
            <div key={key} style={{ paddingRight: 8 }}>
              {key}: {variants[key].name}
            </div>
          )
        )}
      </Row>
    );
  }
  
  renderPrice = ( productOrder, productIndex, holdingListId ) => {
    
    let bulkDiscount = [];

    let totalPrice = this.getTotalPrice( productOrder );

    const BulkDiscountButton = ({ discount, productDiscount }) => (
      <Button 
        type={ productDiscount === discount && productOrder.quantity > 1? "primary": "" }
        onClick={() => this.onSetBulkDiscount({
          discount, 
          productIndex, 
          holdingListId
        })} 
        size="small">- {discount}%</Button>
    );

    let productBulkDiscount = productOrder.product.bulkDiscount.sort(
      ( a, b ) => {
        return a.quantity > b.quantity
      }
    );

    if( productBulkDiscount.length > 0 && productOrder.quantity >= productBulkDiscount[0].quantity ){

      // if( productOrder.quantity >= productBulkDiscount[0].quantity ){

      let discountTier = productBulkDiscount.reduce(
        ( acc, cur ) => {

          if ( productOrder.quantity >= cur.quantity ) {
            return cur;
          }

          return acc;
        }, {}
      )

      bulkDiscount = (
        <Col>
          Bulk Discount {discountTier.quoteAndForgetCustomBulkDiscount}% Applied
        </Col>
      )
        // render product 
      // }

      // if( productOrder.quantity <= productBulkDiscount[0].quantity ){

        // bulkDiscount = [
        //   <Col>
        //     <BulkDiscountButton discount={0} />
        //   </Col>,
        //   <Col>
        //     <BulkDiscountButton discount={3} />
        //   </Col>,
        //   <Col>
        //     <BulkDiscountButton discount={5} />
        //   </Col>,
        //   <Col>
        //     <BulkDiscountButton discount={7} />
        //   </Col>,
        //   <Col>
        //     <BulkDiscountButton discount={10} />
        //   </Col>
        // ]
      //   // render product 
      // } else {

      //   let discountTier = productBulkDiscount.reduce(
      //     ( acc, cur ) => {

      //       if ( productOrder.quantity >= cur.quantity ) {
      //         return cur;
      //       }

      //       return acc;
      //     }, {}
      //   )

      //   bulkDiscount = (
      //     <Col>
      //       Bulk Discount {discountTier.quoteAndForgetCustomBulkDiscount}% Applied
      //     </Col>
      //   )
      // }
    } else {
      bulkDiscount = [
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={0} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={3} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={5} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={7} />
        </Col>,
        <Col>
          <BulkDiscountButton productDiscount={productOrder.quoteAndForgetCustomBulkDiscount} discount={10} />
        </Col>
      ]
    }

    return (
      <Row type="flex" align="middle" gutter={8}>

        <Col>
          ${totalPrice}
          {/* {productOrder.product.price.po} */}
        </Col>
        {/* {variantKeys.map(
          key => (
            <Col key={key}>
              + {productOrder.variants[key].price.po}
            </Col>
          )
        )} */}
        {bulkDiscount}
      </Row>  
    )
  }

  state = {

    selectedList: {},
    activeKeys: {},
    generatedCheckboxes: [{ checked: false }]
  
  }
  
  constructor( props ){
    super(props);
    
    this._dbnceUpdateHoldingListQuantity = debounce( this._dbnceUpdateHoldingListQuantity, 300 );

  }


  onSetBulkDiscount = ({ discount, productIndex, holdingListId }) => {
    _postSetCustomBulkDiscount({
      discount, 
      productIndex, 
      holdingListId
    })
      .then( res => {
        // this.props.setHoldingListBulkDiscount({
        //   discount, 
        //   productIndex, 
        //   holdingListId
        // })

        this.props.setHoldingListProduct({
          product: res.data.product,
          productIndex,
          holdingListId
        });

      })
      .catch( e => {
        console.log( e.response.data )
        message.error( e.response.data.msg )
      })
  }
  
  /**
   * 
   * @todo handle response
   * 
   */
  _dbnceUpdateHoldingListQuantity = ({ holdingListId, productIndex, quantity }) => {
    _postUpdateHoldingListQuantity({ holdingListId, productIndex, quantity })
      .then( res => {
        message.destroy();
        message.success(`${res.data.product.product.title} -> ${quantity}`);

        this.props.setHoldingListProduct({
          product: res.data.product,
          productIndex,
          holdingListId
        });

      });
  }

  getTotalPrice = ( productOrder ) => {
    // let totalPrice = productOrder.product.price.original;

    // let variantKeys = [];
  
    // if( productOrder.variants ){
    //   variantKeys = Object.keys(productOrder.variants);
    // }

    // variantKeys.map( (key) => {
    //   totalPrice += productOrder.variants[key].price.original;
    // });

    // totalPrice = totalPrice * productOrder.quantity;

    // let productBulkDiscount = productOrder.product.bulkDiscount.sort(
    //   ( a, b ) => {
    //     return a.quantity > b.quantity
    //   }
    // );
    // // totalPrice = 
    // let discountTier = productBulkDiscount.reduce(
    //   ( acc, cur ) => {

    //     if ( productOrder.quantity >= cur.quantity ) {
    //       return cur;
    //     }

    //     return acc;
    //   }, {
    //     discount: 0
    //   }
    // );

    // if( productOrder.quoteAndForgetCustomBulkDiscount > 0 ){

    // }
    // totalPrice = totalPrice * ( (100 - discountTier.quoteAndForgetCustomBulkDiscount) / 100);

    // return totalPrice;

    return productOrder.totalAmount.price;
  }

  handleChangeSerialNumber = (holdingListId, newSerialNumber, productIndex) => {

    this.props.updateHoldingListProductSerialNumber({
      serialNumber: newSerialNumber,
      holdingListId,
      productIndex
    })

  }

  /**
   * @todo handle response 
   */
  handleDeleteHoldingList = ( holdingListId ) => {
    // let _id = this.props.createdLists[index]._id;
    _deleteHoldingList( holdingListId )
      .then(res => {

        this.props.updateHoldingLists(
          this.props.holdingList.filter(
            hl => {

              if( hl._id === holdingListId ){
                message.success(`Deleted ${hl.name}`);
              }

              return hl._id !== holdingListId;
            }
          )
        );
      }).catch(err => {
        // alert( JSON.stringify(err.response) );
      });
  }

  handleDeleteProduct = (holdingListId, productIndex) => {
 
    const { holdingList } = this.props;

    let product = holdingList.reduce(
      ( acc, cur ) => {
        if( cur._id === holdingListId ){
          return cur.products[productIndex];
        }

        return acc;
      }, {}
    );

    let loadingMsg = message.loading(`Deleting ${product.product.title}`, 0);

    setTimeout( () => {
      _deleteHoldingListProduct({
        holdingListId,
        productIndex
      })
        .then( res => {
  
          loadingMsg();
  
          this.props.deleteHoldingListProduct({
            holdingListId,
            productIndex
          });

        })
    }, 300 )

    
    // axios({
    //   url: `${API_ENDPOINT}/api/admin/holding-list/${holdingLists[index]._id}`,
    //   withCredentials: true,
    //   method: 'post',
    //   data: {
    //     newHL: holdingLists[index]
    //   }
    // }).then(res => {
    //   console.log(res.data);
    //   this.props.updateHoldingLists(res.data.holdingList);
    // })
    //   .catch(err => console.log(err));
  }

  onQuantityChange = ({
    holdingListId,
    productIndex,
    quantity
  }) => {

    let actualValue;

    if ( quantity === null) {
      actualValue = 1;
    } else {
      actualValue = quantity;
    }
    
    // _postUpdateHoldingListQuantity
    
    this.props.updateHoldingListProductQuantity({
      quantity: actualValue,
      holdingListId,
      productIndex
    })
    
    this._dbnceUpdateHoldingListQuantity({
      quantity: actualValue,
      holdingListId,
      productIndex
    })
    
    // holdingLists[index].products[listIndex].quantity = actualValue;

    // axios({
    //   url: `${API_ENDPOINT}/api/admin/holding-list/${holdingLists[index]._id}`,
    //   withCredentials: true,
    //   method: 'post',
    //   data: {
    //     newHL: holdingLists[index]
    //   }
    // }).then(res => {
    //   console.log(res.data);
    //   this.props.updateHoldingLists(res.data.holdingList);
    // })
    //   .catch(err => console.log(err));
  }

  
  handleOnToggleCollapse = ( keys ) => {
    // console.log(keys, activeKeys);

    this.setState({ activeKeys: [ ...keys ]})
    // keys.map(
    //   key => 
    // )

    // console.log( key );

    // if( activeKeys[key] ){
    //   this.setState({
    //     activeKeys: {
    //       ...this.state.activeKeys,
    //       [key]: false
    //     }
    //   })
    // } else {
    //   this.setState({
    //     activeKeys: {
    //       ...this.state.activeKeys,
    //       [key]: true
    //     }
    //   })
    // }

  }

  handleReorderHoldingList = (holdingListId) => {
   

    let holdingListProductsSerialNumber = this.props.holdingList.filter( hl => hl._id === holdingListId )[0].products.reduce(
      ( acc, cur ) => {

        acc.push( cur.serialNumber );

        return acc;
      }, []
    );

    _postUpdateHoldingListSerialNumber({
      holdingListId,
      holdingListProductsSerialNumber
    })
      .then( res => {
        this.props.updateHoldingLists(res.data.holdingList);
        
      })

  }

}

export default connect(
	state => ({
		quotation: state.quotation
	}),

	dispatchEvent => ({
    // setHoldingListProduct: ( product, productIndex ) => dispatchEvent( setHoldingListProduct( product, productIndex ) )
		// setQuotationActiveBilling: ( address ) => dispatchEvent( setQuotationActiveBilling(address) ),
		// setQuotationActiveShipping: ( address ) => dispatchEvent( setQuotationActiveShipping(address) ),
		// setQuotationUser: ( user ) => dispatchEvent( setQuotationUser( user ) ),
		// setQuotationUserNewAddress: ( address ) => dispatchEvent( setQuotationUserNewAddress( address) )
	})
)(HoldingList);


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/holdinglist.js